import { render, staticRenderFns } from "./SecondTab.vue?vue&type=template&id=b2fb873c&scoped=true"
import script from "./SecondTab.vue?vue&type=script&lang=js"
export * from "./SecondTab.vue?vue&type=script&lang=js"
import style0 from "./SecondTab.vue?vue&type=style&index=0&id=b2fb873c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fb873c",
  null
  
)

export default component.exports